/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type { AdminSeedService } from './AdminSeedService';
import { adminSeedService } from './AdminSeedService';
import type { AgentBlocksService } from './AgentBlocksService';
import { agentBlocksService } from './AgentBlocksService';
import type { AgentConfigsService } from './AgentConfigsService';
import { agentConfigsService } from './AgentConfigsService';
import type { AgentService } from './AgentService';
import { agentService } from './AgentService';
import type { AgentToolsService } from './AgentToolsService';
import { agentToolsService } from './AgentToolsService';
import type { AgentToolsV2Service } from './AgentToolsV2Service';
import { agentToolsV2Service } from './AgentToolsV2Service';
import type { AgentVoiceService } from './AgentVoiceService';
import { agentVoiceService } from './AgentVoiceService';
import type { AttachmentsService } from './AttachmentsService';
import { attachmentsService } from './AttachmentsService';
import type { AvailabilityService } from './AvailabilityService';
import { availabilityService } from './AvailabilityService';
import type { BookingDecisionsAdminService } from './BookingDecisionsAdminService';
import { bookingDecisionsAdminService } from './BookingDecisionsAdminService';
import type { CallsService } from './CallsService';
import { callsService } from './CallsService';
import type { CheckService } from './CheckService';
import { checkService } from './CheckService';
import type { CustomerPaymentMethodsService } from './CustomerPaymentMethodsService';
import { customerPaymentMethodsService } from './CustomerPaymentMethodsService';
import type { CustomersService } from './CustomersService';
import { customersService } from './CustomersService';
import type { DocumentsService } from './DocumentsService';
import { documentsService } from './DocumentsService';
import type { EmailsService } from './EmailsService';
import { emailsService } from './EmailsService';
import type { EmployeeBlockedTimesService } from './EmployeeBlockedTimesService';
import { employeeBlockedTimesService } from './EmployeeBlockedTimesService';
import type { EmployeeShiftsService } from './EmployeeShiftsService';
import { employeeShiftsService } from './EmployeeShiftsService';
import type { EmployeesService } from './EmployeesService';
import { employeesService } from './EmployeesService';
import type { EventsService } from './EventsService';
import { eventsService } from './EventsService';
import type { ExternalCallsService } from './ExternalCallsService';
import { externalCallsService } from './ExternalCallsService';
import type { FieldReportService } from './FieldReportService';
import { fieldReportService } from './FieldReportService';
import type { FrUsageAdminService } from './FrUsageAdminService';
import { frUsageAdminService } from './FrUsageAdminService';
import type { IntegrationsService } from './IntegrationsService';
import { integrationsService } from './IntegrationsService';
import type { InternalService } from './InternalService';
import { internalService } from './InternalService';
import type { InvoicesService } from './InvoicesService';
import { invoicesService } from './InvoicesService';
import type { IssuesService } from './IssuesService';
import { issuesService } from './IssuesService';
import type { LocationsService } from './LocationsService';
import { locationsService } from './LocationsService';
import type { MetricsObservabilityService } from './MetricsObservabilityService';
import { metricsObservabilityService } from './MetricsObservabilityService';
import type { MetricsService } from './MetricsService';
import { metricsService } from './MetricsService';
import type { NotesService } from './NotesService';
import { notesService } from './NotesService';
import type { NotificationsService } from './NotificationsService';
import { notificationsService } from './NotificationsService';
import type { NotificationTemplatesService } from './NotificationTemplatesService';
import { notificationTemplatesService } from './NotificationTemplatesService';
import type { NotificationTriggersService } from './NotificationTriggersService';
import { notificationTriggersService } from './NotificationTriggersService';
import type { OfficeDataHealthService } from './OfficeDataHealthService';
import { officeDataHealthService } from './OfficeDataHealthService';
import type { OfficeRegionsService } from './OfficeRegionsService';
import { officeRegionsService } from './OfficeRegionsService';
import type { OfficeSettingsAdminService } from './OfficeSettingsAdminService';
import { officeSettingsAdminService } from './OfficeSettingsAdminService';
import type { OfficesService } from './OfficesService';
import { officesService } from './OfficesService';
import type { OrganizationsService } from './OrganizationsService';
import { organizationsService } from './OrganizationsService';
import type { PaymentProvidersService } from './PaymentProvidersService';
import { paymentProvidersService } from './PaymentProvidersService';
import type { PaymentsService } from './PaymentsService';
import { paymentsService } from './PaymentsService';
import type { ProductApplicationMethodsService } from './ProductApplicationMethodsService';
import { productApplicationMethodsService } from './ProductApplicationMethodsService';
import type { ProductsService } from './ProductsService';
import { productsService } from './ProductsService';
import type { RetellService } from './RetellService';
import { retellService } from './RetellService';
import type { RoutesService } from './RoutesService';
import { routesService } from './RoutesService';
import type { SchedulingService } from './SchedulingService';
import { schedulingService } from './SchedulingService';
import type { ServiceEventAttendanceService } from './ServiceEventAttendanceService';
import { serviceEventAttendanceService } from './ServiceEventAttendanceService';
import type { ServiceEventProductUseService } from './ServiceEventProductUseService';
import { serviceEventProductUseService } from './ServiceEventProductUseService';
import type { ServiceEventsService } from './ServiceEventsService';
import { serviceEventsService } from './ServiceEventsService';
import type { ServicePlansService } from './ServicePlansService';
import { servicePlansService } from './ServicePlansService';
import type { ServicePlanTemplatesService } from './ServicePlanTemplatesService';
import { servicePlanTemplatesService } from './ServicePlanTemplatesService';
import type { ServiceTargetAreasService } from './ServiceTargetAreasService';
import { serviceTargetAreasService } from './ServiceTargetAreasService';
import type { ServiceTypesService } from './ServiceTypesService';
import { serviceTypesService } from './ServiceTypesService';
import type { ServiceTypeTemplateQuestionsService } from './ServiceTypeTemplateQuestionsService';
import { serviceTypeTemplateQuestionsService } from './ServiceTypeTemplateQuestionsService';
import type { ServiceTypeTemplatesService } from './ServiceTypeTemplatesService';
import { serviceTypeTemplatesService } from './ServiceTypeTemplatesService';
import type { SimulatorService } from './SimulatorService';
import { simulatorService } from './SimulatorService';
import type { SkillsService } from './SkillsService';
import { skillsService } from './SkillsService';
import type { TagsService } from './TagsService';
import { tagsService } from './TagsService';
import type { TeamsService } from './TeamsService';
import { teamsService } from './TeamsService';
import type { VoiceSettingsService } from './VoiceSettingsService';
import { voiceSettingsService } from './VoiceSettingsService';
import type { WebhooksService } from './WebhooksService';
import { webhooksService } from './WebhooksService';
import type { WorklogsService } from './WorklogsService';
import { worklogsService } from './WorklogsService';

export type Services = {
  organizations: OrganizationsService;
  offices: OfficesService;
  officeDataHealth: OfficeDataHealthService;
  officeRegions: OfficeRegionsService;
  customers: CustomersService;
  customerPaymentMethods: CustomerPaymentMethodsService;
  documents: DocumentsService;
  attachments: AttachmentsService;
  emails: EmailsService;
  locations: LocationsService;
  notes: NotesService;
  notificationTemplates: NotificationTemplatesService;
  notificationTriggers: NotificationTriggersService;
  notifications: NotificationsService;
  employees: EmployeesService;
  employeeBlockedTimes: EmployeeBlockedTimesService;
  employeeShifts: EmployeeShiftsService;
  worklogs: WorklogsService;
  issues: IssuesService;
  invoices: InvoicesService;
  payments: PaymentsService;
  skills: SkillsService;
  teams: TeamsService;
  serviceTypeTemplates: ServiceTypeTemplatesService;
  servicePlanTemplates: ServicePlanTemplatesService;
  servicePlans: ServicePlansService;
  serviceTypes: ServiceTypesService;
  serviceTypeTemplateQuestions: ServiceTypeTemplateQuestionsService;
  serviceTargetAreas: ServiceTargetAreasService;
  products: ProductsService;
  productApplicationMethods: ProductApplicationMethodsService;
  serviceEvents: ServiceEventsService;
  serviceEventAttendance: ServiceEventAttendanceService;
  serviceEventProductUse: ServiceEventProductUseService;
  fieldReport: FieldReportService;
  events: EventsService;
  availability: AvailabilityService;
  routes: RoutesService;
  scheduling: SchedulingService;
  agent: AgentService;
  agentVoice: AgentVoiceService;
  agentConfigs: AgentConfigsService;
  agentBlocks: AgentBlocksService;
  agentTools: AgentToolsService;
  agentToolsV2: AgentToolsV2Service;
  voiceSettings: VoiceSettingsService;
  check: CheckService;
  calls: CallsService;
  retell: RetellService;
  externalCalls: ExternalCallsService;
  metrics: MetricsService;
  tags: TagsService;
  paymentProviders: PaymentProvidersService;
  webhooks: WebhooksService;
  integrations: IntegrationsService;
  metricsObservability: MetricsObservabilityService;
  simulator: SimulatorService;
  officeSettingsAdmin: OfficeSettingsAdminService;
  frUsageAdmin: FrUsageAdminService;
  bookingDecisionsAdmin: BookingDecisionsAdminService;
  adminSeed: AdminSeedService;
  internal: InternalService;
};
export const services = {
  organizations: organizationsService,
  offices: officesService,
  officeDataHealth: officeDataHealthService,
  officeRegions: officeRegionsService,
  customers: customersService,
  customerPaymentMethods: customerPaymentMethodsService,
  documents: documentsService,
  attachments: attachmentsService,
  emails: emailsService,
  locations: locationsService,
  notes: notesService,
  notificationTemplates: notificationTemplatesService,
  notificationTriggers: notificationTriggersService,
  notifications: notificationsService,
  employees: employeesService,
  employeeBlockedTimes: employeeBlockedTimesService,
  employeeShifts: employeeShiftsService,
  worklogs: worklogsService,
  issues: issuesService,
  invoices: invoicesService,
  payments: paymentsService,
  skills: skillsService,
  teams: teamsService,
  serviceTypeTemplates: serviceTypeTemplatesService,
  servicePlanTemplates: servicePlanTemplatesService,
  servicePlans: servicePlansService,
  serviceTypes: serviceTypesService,
  serviceTypeTemplateQuestions: serviceTypeTemplateQuestionsService,
  serviceTargetAreas: serviceTargetAreasService,
  products: productsService,
  productApplicationMethods: productApplicationMethodsService,
  serviceEvents: serviceEventsService,
  serviceEventAttendance: serviceEventAttendanceService,
  serviceEventProductUse: serviceEventProductUseService,
  fieldReport: fieldReportService,
  events: eventsService,
  availability: availabilityService,
  routes: routesService,
  scheduling: schedulingService,
  agent: agentService,
  agentVoice: agentVoiceService,
  agentConfigs: agentConfigsService,
  agentBlocks: agentBlocksService,
  agentTools: agentToolsService,
  agentToolsV2: agentToolsV2Service,
  voiceSettings: voiceSettingsService,
  check: checkService,
  calls: callsService,
  retell: retellService,
  externalCalls: externalCallsService,
  metrics: metricsService,
  tags: tagsService,
  paymentProviders: paymentProvidersService,
  webhooks: webhooksService,
  integrations: integrationsService,
  metricsObservability: metricsObservabilityService,
  simulator: simulatorService,
  officeSettingsAdmin: officeSettingsAdminService,
  frUsageAdmin: frUsageAdminService,
  bookingDecisionsAdmin: bookingDecisionsAdminService,
  adminSeed: adminSeedService,
  internal: internalService,
} as const;
